import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminForgotPassword } from '../api/adminApi';

const AdminForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      await adminForgotPassword(email);
      setIsSubmitted(true);
      toast.success('Password reset instructions sent to your email!');
    } catch (err) {
      const errorMessage = err.response?.data?.error || err.message || 'Failed to send reset instructions.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fullscreen-container">
      <div className="card w-full max-w-md p-8">
        <h2 className="text-2xl font-bold text-center mb-2">Reset Password</h2>
        <p className="text-center text-sm text-brand-muted mb-6">
          Enter your email to receive reset instructions
        </p>

        {!isSubmitted ? (
          <form className="space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-500/20 text-red-400 p-3 rounded-lg text-center">
                {error}
              </div>
            )}
            <div>
              <label htmlFor="email" className="sr-only">Email address</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field"
                placeholder="Email address"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-full"
            >
              {loading ? 'Sending...' : 'Send Reset Instructions'}
            </button>
          </form>
        ) : (
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-500/20">
              <i className="bi bi-check-lg text-green-400 text-2xl" />
            </div>
            <h3 className="mt-4 text-lg font-medium">Check your email</h3>
            <p className="mt-2 text-sm text-brand-muted">
              If an account exists with the email <strong>{email}</strong>, you will receive password reset instructions.
            </p>
          </div>
        )}

        <div className="text-center mt-6">
          <Link
            to="/admin/login"
            className="text-sm text-brand-yellow hover:underline"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPassword; 